import { PERIODS, periodsMap } from '../../constants';

const getLimitPeriod = (delta) => {
  if (!delta) {
    return PERIODS.INDEFINITE;
  }
  const period = Object.entries(periodsMap).find(([, p]) => p.delta === delta);
  const [idx] = period || [];
  return idx || undefined;
};

export default getLimitPeriod;
